import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "@/components/site/Icon";

/**
 * Standards alignment row — "Informed by internationally recognized practices."
 * Reference layout: left column with heading/paragraph/link, right column with a small grid of framework tiles.
 */
export default function StandardsList({ section }) {
  const { eyebrow, heading, paragraphs = [], cards = [], ctas = [] } = section;
  const primaryCta = ctas[0];

  return (
    <section className="bg-white py-24 lg:py-32 border-y border-mist-soft">
      <div className="container-mist">
        <div className="max-w-3xl">
          {heading && (
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight text-mist-navy">{heading}</h2>
          )}
          {paragraphs[0] && (
            <p className="mt-4 text-base text-mist-ink/75 leading-relaxed">{paragraphs[0]}</p>
          )}
          {primaryCta && (
            <Link
              to={primaryCta.href}
              data-testid={primaryCta.testid || "standards-link"}
              className="mt-6 inline-flex items-center gap-2 text-mist-navy text-xs uppercase tracking-[0.22em] hover:text-mist-gold transition link-underline"
            >
              {primaryCta.label} <ArrowRight className="h-3.5 w-3.5" aria-hidden />
            </Link>
          )}
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {cards.map((c, i) => (
            <div
              key={i}
              data-testid={`standard-${i}`}
              className="bg-mist-off border border-mist-soft rounded-md p-6 md:p-8 text-center flex flex-col items-center"
            >
              <Icon name={c.icon || "badge-check"} className="h-12 w-12 text-mist-gold mb-4" />
              <div className="text-lg md:text-xl tracking-tight text-mist-navy font-semibold leading-tight">
                {c.title || c.description}
              </div>
              {c.caption && (
                <div className="text-sm md:text-base text-mist-navy/70 mt-2 leading-relaxed">{c.caption}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
